import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap5/Form';

import { useTableContext } from './TableContext';
import Checkbox from './Checkbox';
import Actions from './Actions';
import NumericField from '../NumericField';
import WithTooltip from '../WithTooltip';
import RowActions from './RowActions';

export default function parseColumns(rawColumns, selectableRows, selectableRowDisabled, rowActions) {
  const { state, dispatch } = useTableContext();

  const columns = rawColumns.map((column) => {
    const oldFormat = React.useMemo(() => column.format, []);

    column.format = (row) => {
      let value = oldFormat ? oldFormat(row) : column.selector(row);

      if (column.numeric) {
        value = <NumericField content={value} />;
      }

      if (column.with_tooltip) {
        value = <WithTooltip content={value} />;
      }

      return value;
    };

    return column;
  });

  if (selectableRows) {
    columns.unshift({
      name: <Checkbox />,
      cell: (row) => (
        <Form.Check
          checked={state.selectedRows.includes(row.id)}
          disabled={selectableRowDisabled(row)}
          onChange={
          (e) => Actions.selectRow(dispatch, row, e.currentTarget.checked)
        }
        />
      ),
      minWidth: 'auto',
    });
  }

  if (rowActions.length > 0) {
    columns.push({
      name: '',
      cell: (row) => <RowActions row={row} actions={rowActions} />,
      minWidth: '56px',
      style: {
        alignItems: 'center',
        backgroundColor: 'inherit',
        display: 'flex',
        padding: 0,
        position: 'absolute',
        right: 0,
      },
    });
  }

  return columns;
}

parseColumns.propTypes = {
  rawColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectableRows: PropTypes.bool,
  selectableRowDisabled: PropTypes.func,
  rowActions: PropTypes.arrayOf(PropTypes.object),
};

parseColumns.defaultProps = {
  selectableRows: true,
  selectableRowDisabled: () => {},
  rowActions: [],
};
